export default __webpack_public_path__ + "assets/practice-4305524.svg";